import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SvgAvatarModule } from 'shared/components/svg-avatar';
import { SvgIconModule } from 'shared/components/svg-icon/svg-icon.module';
import { GenesysContactDisplayNameModule } from 'shared/components/genesys-contact-display-name/genesys-contact-display-name.module';
import { GenesysWidgetHeaderToolsModule } from 'shared/components/genesys-widget-header-tools';
import { GenesysChatWidgetComponent } from './genesys-chat-widget.component';
import { GenesysChatWidgetHeaderComponent } from './genesys-chat-widget-header/genesys-chat-widget-header.component';
import { InactiveWidgetFooterModule } from 'components/work-item-lane-list/work-item-lane/work-item-widget/shared/components/inactive-widget-footer/inactive-widget-footer.module';
import { CopyTextToClipboardModule } from 'shared/components/copy-text-to-clipboard/copy-text-to-clipboard.module';
import { GenesysChatBoxComponent } from './genesys-chat-box/genesys-chat-box.component';
import { GenesysChatMessageListComponent } from './genesys-chat-box/genesys-chat-message-list/genesys-chat-message-list.component';
import { GenesysChatMessageListItemComponent } from './genesys-chat-box/genesys-chat-message-list-item/genesys-chat-message-list-item.component';
import { GenesysChatBoxScrollableBodyComponent } from './genesys-chat-box/genesys-chat-box-scrollable-body/genesys-chat-box-scrollable-body.component';
import { ClosingConfirmationService } from 'shared/components/confirmation-modal/confirmation-modal.service';
import { GenesysChatButtonsComponent } from './genesys-chat-box/genesys-chat-buttons/genesys-chat-buttons.component';
import { GenesysChatFooterComponent } from './genesys-chat-box/genesys-chat-footer/genesys-chat-footer.component';
import { WorkItemWidgetSharedModule } from 'components/work-item-lane-list/work-item-lane/work-item-widget/shared/work-item-widget-shared.module';
import { GenesysEditorModule } from 'shared/components/genesys-editor/genesys-editor.module';
import { GenesysTransferPanelModule } from 'shared/components/genesys-transfer-panel/genesys-transfer-panel.module';
import { AutoSaveModule } from 'common/auto-save/auto-save.module';
import { GenesysIntegrationPanelModule } from 'shared/components/genesys-integration-panel/genesys-integration-panel.module';
import { GenesysWrapupPanelModule } from 'shared/components/genesys-wrapup-panel/genesys-wrapup-panel.module';
import { GenesysUserPermissionCheckModule } from 'shared/directives/genesys-user-permission-check';
import { GenesysChatFileUploadBoxComponent } from './genesys-chat-box/genesys-chat-file-upload-box/genesys-chat-file-upload-box.component';
import { LinkyModule } from 'ngx-linky';
import { SimpleToastGroupModule } from 'shared/components/simple-toast-group';
import { GenesysChatToastMessagesComponent } from './genesys-chat-box/genesys-chat-toast-messages/genesys-chat-toast-messages.component';
import { GenesysCobrowseBoxModule } from './genesys-cobrowse-box/genesys-cobrowse-box.module';
import { ChatPeriodEndedTextPipe } from './genesys-chat-box/genesys-chat-message-list/pipes/chat-period-ended-text.pipe';
import { ChatMessageStatusIconClassPipe } from './genesys-chat-box/genesys-chat-message-list-item/pipes/chat-message-status-icon-class.pipe';
import { ChatMessageStatusTranslationKeyPipe } from './genesys-chat-box/genesys-chat-message-list-item/pipes/chat-message-status-translation-key.pipe';
import { MoreActionsPanelModule } from '../shared/components/more-actions-panel/more-actions-panel.module';
import { CustomPipesModule } from 'shared/pipes/custom-pipes.module';
import { GenesysChatMessageTypingIndicatorComponent } from './genesys-chat-box/genesys-chat-message-typing-indicator/genesys-chat-message-typing-indicator.component';
import { GenesysChatMessageCardComponent } from './genesys-chat-box/genesys-chat-message-card/genesys-chat-message-card.component';
import { GenesysIframeModule } from 'shared/components/genesys-iframe/genesys-iframe.module';

@NgModule({
  declarations: [
    GenesysChatWidgetComponent,
    GenesysChatWidgetHeaderComponent,
    GenesysChatBoxComponent,
    GenesysChatBoxScrollableBodyComponent,
    GenesysChatButtonsComponent,
    GenesysChatFooterComponent,
    GenesysChatMessageListComponent,
    GenesysChatMessageListItemComponent,
    GenesysChatFileUploadBoxComponent,
    GenesysChatToastMessagesComponent,
    ChatPeriodEndedTextPipe,
    ChatMessageStatusIconClassPipe,
    ChatMessageStatusTranslationKeyPipe,
    GenesysChatMessageTypingIndicatorComponent,
    GenesysChatMessageCardComponent
  ],
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    SvgAvatarModule,
    SvgIconModule,
    LinkyModule,
    InactiveWidgetFooterModule,
    CopyTextToClipboardModule,
    GenesysContactDisplayNameModule,
    WorkItemWidgetSharedModule,
    GenesysEditorModule,
    AutoSaveModule,
    GenesysWidgetHeaderToolsModule,
    WorkItemWidgetSharedModule,
    GenesysTransferPanelModule,
    GenesysIntegrationPanelModule,
    GenesysWrapupPanelModule,
    GenesysUserPermissionCheckModule,
    SimpleToastGroupModule,
    GenesysCobrowseBoxModule,
    MoreActionsPanelModule,
    CustomPipesModule,
    GenesysIframeModule
  ],
  providers: [ClosingConfirmationService],
  exports: [GenesysChatWidgetComponent]
})
export class GenesysChatWidgetModule {}
